import React from "react";
import { Link } from "react-router-dom";
import { Heart, GraduationCap, Monitor } from "lucide-react";
import { FEATURED_COURSE_LINKS } from "../lib/courseTypes";

const ICONS = {
  Heart,
  GraduationCap,
  Monitor,
};

function PopularCourses() {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {FEATURED_COURSE_LINKS.map(({ label, path, icon }) => {
        const Icon = ICONS[icon];
        return (
          <Link
            key={path}
            to={path}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-50 text-emerald-700 text-sm font-bold border border-emerald-100 hover:bg-emerald-100 hover:border-emerald-200 transition-colors"
          >
            {Icon && <Icon size={15} className="text-emerald-600" />}
            {label}
          </Link>
        );
      })}
    </div>
  );
}

export default PopularCourses;
